/**
 * Created by Sale on 8/29/2024
 */
import {Role} from "@/utils/utils";
import dtpQueryPage from "@/modules/dtp-query/views/dtp-query-page/dtp-query-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/dtp-query",
    component: Module,
    children: [
        {
            path: '/',
            name: 'dtp-query',
            meta: {
                product: 'Realite Admin',
                title: 'DTP Query',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'dtp-query:get-report',
                topBarTitle: '',
                menuPriority: 11,
                hasMenu: true,
                hasInternalTransition: false
            },
            component: dtpQueryPage
        }
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
